import { render, staticRenderFns } from "./UserGroup.vue?vue&type=template&id=aaba4f26&"
import script from "./UserGroup.vue?vue&type=script&lang=js&"
export * from "./UserGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3794794342/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaba4f26')) {
      api.createRecord('aaba4f26', component.options)
    } else {
      api.reload('aaba4f26', component.options)
    }
    module.hot.accept("./UserGroup.vue?vue&type=template&id=aaba4f26&", function () {
      api.rerender('aaba4f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/UserGroup.vue"
export default component.exports